import http from "./http";

// GET all packages
export const getPackages = async () => {
  const res = await http.get("manage_packages");
  return res.data;
};

// ADD / UPDATE packages (same API)
export const savePackages = async (packages) => {
  /**
   * packages = [
   *   { price: 70, points: 100 },
   *   { id: 1, price: 50, points: 100 }
   * ]
   */
  const res = await http.post("manage_packages", {
    packages,
  });
  return res.data;
};

// DELETE package
export const deletePackage = async (id) => {
  const res = await http.post("manage_packages", {
    action: "delete",
    id,
  });
  return res.data;
};
